import React from "react";
import AppBar from "@mui/material/AppBar";
import { Box, IconButton, Toolbar, Typography } from "@mui/material";
import { IoIosArrowBack } from "react-icons/io";
import style from "./header.module.css";
import logo from "../assets/dashboard/header icon.svg";
import { useNavigate } from "react-router-dom";
import { BsFillPersonFill } from "react-icons/bs";

const Header = (props) => {
  const navigate = useNavigate();
  const { header, bgColor, navigateRoute } = props;

  const handleBackButton = () => {
    navigateRoute ? navigateRoute() : navigate(-1);
  };
  return (
    <Box
      className={style.container}
      style={{ backgroundColor: bgColor ? bgColor : "" }}
    >
      <Toolbar
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "0.5rem",
          }}
        >
          <IoIosArrowBack
            className={style.backArrowIcon}
            onClick={handleBackButton}
          />
          <h4 className={style.header}>{header}</h4>
        </Box>
        <Box>
          <img src={logo} onClick={() => navigate("/")} />
        </Box>
      </Toolbar>
    </Box>
  );
};

export default Header;
